import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService, TokensService } from '../../services';
import { StorageService } from '../../services/storage.service'
import { AlertService } from '../../alert';

@Component({
    selector: 'app-header',
    providers: [TokensService, StorageService],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    isIn = false;   // store state
    
    userName: any;
    client: string;
    storageName: string;
    clients: any[];
    storages: any[];
    
    constructor(
            private authenticationService: AuthenticationService,
            private tokensService: TokensService,
            private storageService: StorageService,
            private router: Router,
            private alertService: AlertService) { }

    ngOnInit() {
      let token: any = this.authenticationService.getToken();
      this.client = token.clientName;
      this.userName = token.userName;
      this.storageName = this.authenticationService.getStorageName();
      this.tokensService.getClients(token)
            .subscribe(
            data => {
                this.clients = data;
            });
      this.storageService.getStorages(token)
            .subscribe(
              data => {
                this.storages = data;
              });

    }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  toggleState() { // click handler
      let bool = this.isIn;
      this.isIn = bool === false ? true : false; 
  }

  async switchClient(c: any) {
    let token: any = this.authenticationService.getToken();
    this.tokensService.changeClient(token, c.guid)
            .subscribe(
            data => {
                this.authenticationService.setToken(data);
                this.client = data.clientName;
            },
            error => {
              this.alertService.error(error);
            });
  }

  switchStorage(s: any) {
      this.authenticationService.setStorageName(s.name);
      this.storageName = s.name;
  }
  
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/layout/header/header.component.ts